<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="选择样式">
				<el-select filterable v-model="list.styleSelect" value-key="lable" style="width: 100%">
					<el-option :label="optItem.dictLabel" :value="optItem.dictValue" v-for="(optItem, index) in styleSelectData" :key="index + 'option_selected'"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="内边距">
				<el-input-number v-model="list.paddingTop" placeholder="单位像素（px）" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="左边距">
				<el-input-number v-model="list.paddingLeft" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="右边距">
				<el-input-number v-model="list.paddingRight" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-plus" class="add-image" @click="addList"> 添加列 </el-button>
			</el-form-item>
			<el-form-item label="列图片">
				<el-upload
					class="avatar-uploader"
					:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
					:auto-upload="false"
					:show-file-list="false"
					:on-change="
						(file, fileList) => {
							handleImport(file, fileList, 'listImage');
						}
					"
					accept="image/gif,image/jpeg,image/jpg,image/png"
					drag
				>
					<img v-if="list.listImage" :src="list.listImage" class="avatar" />
					<i v-else class="el-icon-upload"></i>
				</el-upload>
			</el-form-item>
		</el-form>

		<el-form label-width="70px">
			<el-form-item class="listData" :label="'第' + (index + 1) + '项'" v-for="(item, index) in list.data" :key="index">
				<el-input v-model="list.data[index].title" placeholder="请输入标题" maxlength="15" show-word-limit></el-input>
				<el-input class="input_two" v-model="list.data[index].subTitle" placeholder="请输入副标题" maxlength="15" show-word-limit></el-input>
				<el-button type="danger" icon="el-icon-delete" circle @click="deleteListData(index)"></el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	name: 'courseVideo',
	props: ['data', 'className'],
	data() {
		return {
			list: {},
			styleSelectData: [
				{ dictLabel: '灵源样式', dictValue: 'is_style_ly' },
				{ dictLabel: '膏方样式', dictValue: 'is_style_gf' },
			],
		};
	},
	mounted() {
		this.list = this.data;
	},
	methods: {
		addList() {
			var index = this.list.data.length + 1;
			this.list.data.push({ title: '', subTitle: '', model: 'text' + index });
		},
		deleteListData(val) {
			delete this.list.data.splice(val, 1);
		},
		handleImport(file, fileList, name) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
			const params = new FormData();
			params.append('file', file.raw);
			var loading = this.$loading({
				lock: true,
				text: '图片上传中',
			});
			var url = 'https://app.kcguoyi.com/api/service/upload/uploadImage';
			axios
				.post(url, params, {
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				.then((res) => {
					this.list[name] = res.data.body[0].url;
				})
				.finally(() => {
					this.$nextTick(() => {
						this.$forceUpdate();
					});
					loading.close();
				});
		},
	},
};
</script>

<style scoped>
.info-content {
	padding: 20px;
	overflow-y: auto;
}
.listData .el-input {
	width: 160px;
}
.listData .el-button {
	float: right;
	margin-top: -15px;
}
.input_two {
	margin-top: 10px;
}

div /deep/ .normal-uploader .el-upload-dragger {
	width: 180px;
	height: 100px;
}
div /deep/ .normal-uploader .el-upload-dragger .el-icon-upload {
	margin-top: 20px;
}

div /deep/ .avatar-uploader .el-upload-dragger {
	width: 120px;
	height: 80px;
}
div /deep/ .avatar-uploader .el-upload-dragger .el-icon-upload {
	margin-top: 15px;
}

.normal-uploader .avatar {
	width: 180px;
	height: 100px;
	display: block;
}

.avatar-uploader .avatar {
	width: 120px;
	height: 80px;
	display: block;
}
</style>